module.exports = __webpack_public_path__ + "static/media/Malaysia-Airlines-Logo-and-wordmark.47ef3cb6.png";